import { Breadcrumb } from '@components/common/breadcrumb';
import { DestinationLinkBuilder, Name } from '@model/iceberg/geography';
import { withTheme } from '@emotion/react';
import React from 'react';
import { Item } from '@components/breadcrumbs/item';
import { TripTypes } from '@model/common';

export interface DestinationBreadcrumbProps {
  destination: Name;
  resort?: Name;
  hotel?: Name;
  tour?: Name;
  tripType?: TripTypes;
}

export const DestinationBreadcrumbComponent = ({
  destination,
  resort,
  hotel,
  tour,
  tripType
}: DestinationBreadcrumbProps) => {
  const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const getItems = () => {
    const items: Array<Item> = [];
    items.push({
      ...builder.getDestinationLink(destination.path, tripType),
      display: destination.display
    });
    if (resort && resort.path) {
      items.push({
        ...builder.getDestinationLink(resort.path),
        display: resort.display
      });
    }
    if (hotel && hotel.path && !tour) {
      items.push({
        ...builder.getDestinationLink(hotel.path, tripType),
        display: hotel.display
      });
    }
    if (tour && tour.path && !hotel) {
      items.push({
        ...builder.getDestinationLink(tour.path, tripType),
        display: tour.display
      });
    }
    return items;
  };
  return <Breadcrumb items={getItems()} tripType={tripType} />;
};

export const DestinationBreadcrumb = withTheme(DestinationBreadcrumbComponent);
